import { render, staticRenderFns } from "./StockOpnameNew.vue?vue&type=template&id=04fa6ee2&"
import script from "./StockOpnameNew.vue?vue&type=script&lang=js&"
export * from "./StockOpnameNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports